var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{domProps:{"innerHTML":_vm._s(require(("SVGPATH/" + _vm.icon + ".svg")))}})])}
var staticRenderFns = []

export { render, staticRenderFns }